import { useState, useContext } from "react";
import getCurrentSkin from "../utils/getCurrentSkin"; // ✅ Make sure path is correct

import TopbarMobile from "./TopbarMobile";
import { ThemeContext } from "../context/ThemeContext";
import ProductionSidebar from "./ProductionSidebar";



const ProductionLayoutWrapper = ({ children }) => {
  const { isDark, skin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin); // ✅ safe always
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div
      className={`${
        isDark ? "bg-neutral-900 text-white" : "bg-gray-100 text-black"
      } flex min-h-screen relative`}
    >
      {/* Mobile Topbar */}
      <TopbarMobile onOpenSidebar={() => setSidebarOpen(true)} />

      {/* Sidebar */}
      <ProductionSidebar
        isMobileOpen={isSidebarOpen}
        onCloseMobile={() => setSidebarOpen(false)}
      />

      {/* Main Content */}
      <main className="flex-1 flex justify-center items-start sm:p-6 p-4 pt-20 sm:pt-6">
        <div
          className={`w-full max-w-[1400px] shadow-2xl min-h-screen p-6 sm:p-8 rounded-tr-[3rem] rounded-br-[3rem] ${
            isDark ? currentSkin.darkContent : currentSkin.content
          }`}
        >
          {children}
        </div>
      </main>
    </div>
  );
};

export default ProductionLayoutWrapper;
